/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Event_Duration_InvalidInputs */



/**
* | output |
* | --- |
* | "Event must be between 2 and 30 seconds to record audio." |
*
* @param {Audio_Recorder_Event_Duration_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_event_duration_invalid = /** @type {((inputs?: Audio_Recorder_Event_Duration_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Event_Duration_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'événement doit durer entre 2 et 30 secondes pour enregistrer l'audio.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Ereignis muss zwischen 2 und 30 Sekunden dauern, um Audio aufzunehmen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per registrare l'audio, l'evento deve durare tra 2 e 30 secondi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для записи звука длительность события должна составлять от 2 до 30 секунд.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El evento debe durar entre 2 y 30 segundos para grabar audio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件持续时间必须在 2 到 30 秒之间才能录制音频。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオを録音するには、イベントの長さが 2 ～ 30 秒である必要があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो रिकॉर्ड करने के लिए इवेंट की अवधि 2 से 30 सेकंड के बीच होनी चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento deve ter entre 2 e 30 segundos para que o áudio seja gravado.")
	return /** @type {LocalizedString} */ ("Event must be between 2 and 30 seconds to record audio.")
});